
export default function AtelierLineCTA() {
  return (
    <section
      className="py-20 sm:py-28 bg-[#0A0A0A] relative overflow-hidden"
      aria-labelledby="af-line-cta-heading"
    >
      {/* BG glow */}
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#06C755]/5 rounded-full blur-[150px]" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6 text-center">
        <div className="w-16 h-16 flex items-center justify-center bg-[#06C755] rounded-2xl mx-auto mb-6">
          <i className="ri-line-fill text-white text-3xl" aria-hidden="true" />
        </div>

        <h2
          id="af-line-cta-heading"
          className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 tracking-tight"
        >
          公式LINEで<br className="sm:hidden" />先行情報をGET
        </h2>

        <p className="text-sm sm:text-base text-white/40 font-light mb-8 max-w-xl mx-auto leading-relaxed">
          Makuake公開前に最速でお届け。先行割引・限定特典の情報もLINEだけで配信します。登録者限定の特別価格でのご案内も予定しています。
        </p>

        {/* Benefits */}
        <div className="grid sm:grid-cols-3 gap-3 sm:gap-4 mb-8 max-w-2xl mx-auto">
          <div className="flex items-center justify-center gap-2 px-4 py-3 bg-[#06C755]/10 border border-[#06C755]/20 rounded-xl">
            <i className="ri-gift-2-line text-[#06C755]" aria-hidden="true" />
            <span className="text-xs sm:text-sm text-white/70 font-light">
              先行割引のご案内
            </span>
          </div>
          <div className="flex items-center justify-center gap-2 px-4 py-3 bg-[#06C755]/10 border border-[#06C755]/20 rounded-xl">
            <i className="ri-notification-3-line text-[#06C755]" aria-hidden="true" />
            <span className="text-xs sm:text-sm text-white/70 font-light">
              公開日の最速通知
            </span>
          </div>
          <div className="flex items-center justify-center gap-2 px-4 py-3 bg-[#06C755]/10 border border-[#06C755]/20 rounded-xl">
            <i className="ri-vip-crown-line text-[#06C755]" aria-hidden="true" />
            <span className="text-xs sm:text-sm text-white/70 font-light">
              LINE限定特典
            </span>
          </div>
        </div>

        <a
          href="https://lin.ee/d6PoCFQ6"
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="inline-flex items-center justify-center gap-2.5 px-10 py-4 bg-[#06C755] hover:bg-[#05B34A] text-white text-base font-medium tracking-wide transition-all duration-300 rounded-xl cursor-pointer whitespace-nowrap hover:shadow-xl hover:shadow-[#06C755]/25 group"
        >
          <i className="ri-line-fill text-2xl" aria-hidden="true" />
          <span>公式LINEで事前登録する</span>
          <i
            className="ri-arrow-right-s-line text-lg group-hover:translate-x-1 transition-transform"
            aria-hidden="true"
          />
        </a>

        <p className="text-[11px] text-white/20 mt-3 font-light">
          無料・いつでもブロック可能
        </p>
      </div>
    </section>
  );
}
